// CMS editors flag a CTA as "open the add-to-calendar picker" by setting its link URL to this
// token instead of a real URL. Tolerates an optional leading "#" and the "calender" misspelling
// since both have shown up in real CMS entries.
const ADD_TO_CALENDAR_URL_PATTERN = /^#?add-to-calend[ae]r$/;

export function isAddToCalendarLink(url?: string): boolean {
  if (!url) return false;
  return ADD_TO_CALENDAR_URL_PATTERN.test(url.trim().toLowerCase());
}
